import React, { useEffect, useState, useContext, useRef } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { IonContent, IonSpinner } from '@ionic/react';
import { createPayment, createTestPayment } from '../../../../global/request/bet';
import { AuthContext } from '../../../authentication/AuthContext';
import StripeForm from '../../summary/StripeForm';
import TakerModalFooter from '../TakerModalFooter';
import TakerModalHeader from '../TakerModalHeader';

import '../../../../styles/fight/takerProcess/PaymentStep.scss';

const PaymentStep = ({ onNext, onBack, makerTotalPrice, onCloseModal, isDelivery, className }) => {
  const authCtx = useContext(AuthContext);

  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const stripeFormRef = useRef(null);

  useEffect(() => {
    const stripeKey =
      window.location.hostname === 'www.getfoodfight.link'
        ? loadStripe(process.env.REACT_APP_STRIPE_LIVE_KEY)
        : loadStripe(process.env.REACT_APP_STRIPE_TEST_KEY);
    setStripePromise(stripeKey);

    async function fetchClientSecret() {
      try {
        if (!makerTotalPrice) {
          console.warn('[PaymentStep] makerTotalPrice is undefined!');
          setErrorMsg('Could not determine payment amount.');
          return;
        }
        const token = authCtx?.tokens?.idToken;
        const amountInCents = Math.round(makerTotalPrice);

        const secret =
          window.location.hostname === 'www.getfoodfight.link'
            ? await createPayment(token, amountInCents, isDelivery)
            : await createTestPayment(token, amountInCents, isDelivery);
        setClientSecret(secret);
      } catch (error) {
        console.error('[PaymentStep] Failed to fetch client secret:', error);
        setErrorMsg('Could not create payment. Please try again.');
      }
    }

    fetchClientSecret();
  }, [authCtx, makerTotalPrice, isDelivery]);

  const handleConfirm = () => {
    if (stripeFormRef.current) {
      stripeFormRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };

  const handlePaymentSuccess = paymentIntent => {
    onNext?.(paymentIntent.id);
  };

  return (
    <div className={className} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <TakerModalHeader pageName='ADD PAYMENT' showBackButton onBack={onBack} onXButton={onCloseModal} />

      <IonContent className='step-content' scrollY style={{ flex: 1 }}>
        {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}

        {!stripePromise && (
          <div className='loading-container'>
            <IonSpinner name='crescent' />
          </div>
        )}
        {!clientSecret && (
          <div className='loading-container'>
            <IonSpinner name='crescent' />
          </div>
        )}

        {stripePromise && clientSecret && (
          <Elements stripe={stripePromise} options={{ clientSecret, appearance: { theme: 'stripe' } }}>
            <StripeForm clientSecret={clientSecret} formSubmitRef={stripeFormRef} onSuccess={handlePaymentSuccess} />
          </Elements>
        )}

        <div className='authorization-info'>
          *By proceeding you authorize a 48 hour hold on your card for the amount listed in the Fight Card.
          Authorization only completed if you lose.
        </div>
      </IonContent>

      <TakerModalFooter buttonName='Confirm' onClick={handleConfirm} progressPercent={0.5} isDisabled={!clientSecret} />
    </div>
  );
};

export default PaymentStep;
